import { createPureImageGridUtils } from './pureImageGrid.js';

const mosaic = createPureImageGridUtils({
	type: 'image-mosaic',
	colCount: 3,
	colGap: 5,
	defaultHeight: 130,
	defaultBorderRadius: 0,
	defaultItemCount: 6,
	imageIdPrefix: 'image-mosaic-item',
	randomStart: 81,
	assetKey: 'imgMosaic',
});

export const IMAGE_MOSAIC_TYPE = mosaic.TYPE;
export const IMAGE_MOSAIC_DEFAULT_HEIGHT = mosaic.DEFAULT_HEIGHT;
export const IMAGE_MOSAIC_COL_COUNT = mosaic.COL_COUNT;
export const IMAGE_MOSAIC_COL_GAP = mosaic.COL_GAP;
export const IMAGE_MOSAIC_H5_SCREEN_WIDTH = 375;
export const IMAGE_MOSAIC_H5_SIDE_INSET = 12;
export const IMAGE_MOSAIC_H5_CONTENT_WIDTH = 351;
export const IMAGE_MOSAIC_PC_SIDE_INSET = 8;
export const IMAGE_MOSAIC_BATCH_SIZE = mosaic.BATCH_SIZE;

export const createDefaultImageMosaicItem = mosaic.createDefaultItem;
export const createDefaultImageMosaicItems = mosaic.createDefaultItems;
export const getImageMosaicDefaults = mosaic.getDefaults;
export const isImageMosaicBlock = mosaic.isBlock;
export const getImageMosaicImageUrl = mosaic.getImageUrl;
export const normalizeImageMosaicData = mosaic.normalizeData;
export const getImageMosaicBlockStyle = mosaic.getBlockStyle;
export const getImageMosaicGalleryUrls = mosaic.getGalleryUrls;
export const getImageMosaicThumbAspectRatio = mosaic.getThumbAspectRatio;
